<div class="preview-container">
  <div class="content-wrapper">
    <div class="inner-wrapper">
      <div class="modal-inner-container" id="modalInnerContainer">
        <div class="header-modal" *ngIf="modalType !== 'assign_number' && modalType !== 'add_promotion'">
          <div
            *ngIf="modalType === 'create_configuration' || modalType === 'edit_configuration' || modalType === 'create_ppi_configuration' || modalType === 'edit_ppi_configuration'"
            class="flex-header">
            <h3 class="modal-description">{{ campaignData?.name ?? '' | translate }}</h3>
          </div>

          <h1 class="modal-title">{{ modalTitle ?? '' | translate }}</h1>
        </div>
        <div class="container-modal">
          <app-assign-ivr-number *ngIf="modalType === 'assign_number' || modalType === 'edit_number'" [configurationData]="$any(configurationData)">
          </app-assign-ivr-number>
          <app-create-configuration
            *ngIf="modalType === 'create_configuration' || modalType === 'edit_configuration' || modalType === 'create_direct_link' || modalType === 'edit_link_configuration'"
            [currentCampaign]="$any(campaignData)"
            [modalType]="modalType"
            [canCreateNumberConfig]="canCreateNumberConfig"
            [configurationData]="configurationData"
            [duplicateModal]="duplicateModal">
          </app-create-configuration>
          <app-add-promotion-method-modal *ngIf="modalType === 'add_promotion'"> </app-add-promotion-method-modal>
          <app-download-buttons-modal *ngIf="modalType === 'choose_button'" [configurationData]="$any(configurationData)"> </app-download-buttons-modal>
        </div>
      </div>

      <button class="btn close-button" (click)="closeModal()">
        <nb-icon icon="cross" pack="icomoon" class="cross-icon"></nb-icon>
      </button>
    </div>
  </div>
</div>
